module.exports = __webpack_public_path__ + "static/media/about_03.ae9a85cd.png";